export const INTERNAL_PORTAL_ID = 137828;
export const INTERNAL_PORTAL_ID_QA = 885765335;
export const GENERATION_PORTAL_ID = 50619635;
export const GENERATION_PORTAL_ID_QA = 911635575;
export const ACADEMY_LABS_SOURCE_PORTAL_ID = 50958693;
export const ACADEMY_LABS_SOURCE_PORTAL_ID_QA = 913439751;